import _assign from 'lodash/assign';
import _get from 'lodash/get';
import _forEach from 'lodash/forEach';
import _clone from 'lodash/clone';
import _concat from 'lodash/concat';
import _findIndex from 'lodash/findIndex';
import _map from 'lodash/map';
import _isArray from 'lodash/isArray';
import _sortBy from 'lodash/sortBy';
import initialState from '../store/initialState';
import ActionTypes from '../constants/ActionTypes';

export default (state = initialState.coding, action) => {
  switch (action.type) {
    case `${ActionTypes.SET_CODING_PROBLEM_DATA}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.problemData));
      if (!temp[action.problemSlug]) temp[action.problemSlug] = action.payload;
      else
        temp[action.problemSlug] = _assign(
          {},
          temp[action.problemSlug],
          action.payload
        );
      return _assign({}, state, { problemData: temp });
    }
    case `${ActionTypes.GET_LANGUAGE_STUB}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.stubs));
      temp[action.language] = action.payload;
      return _assign({}, state, { stubs: temp });
    }
    case `${ActionTypes.SWITCH_EDITOR_THEME}_SUCCESS`:
      return _assign({}, state, { theme: action.theme });
    case ActionTypes.SET_INTELLISENSE_ENABLED:
      return _assign({}, state, { intellisenseEnabled: action.enabled });
    case ActionTypes.SET_DEFAULT_LANGUAGE:
      sessionStorage.setItem('defaultLanguage', action.language);
      return _assign({}, state, { defaultLanguage: action.language });
    case `${ActionTypes.SAVE_CODING_PROBLEM}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.solution));
      const problemSlug = _get(action.payload, 'problem.slug', null);
      temp[problemSlug] = action.payload;
      return _assign({}, state, { solution: temp });
    }
    case ActionTypes.SET_INIT_CODE_IN_SOLUTION: {
      const temp = JSON.parse(JSON.stringify(state.solution));
      /**
       * Should not overwrite the solution if present
       */
      if (!temp[action.problemSlug]) {
        temp[action.problemSlug] = {
          technology: action.languageUri,
        };
      }
      return _assign({}, state, { solution: temp });
    }
    case `${ActionTypes.CHANGE_LANGUAGE}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.solution));
      const problemTemp = JSON.parse(JSON.stringify(state.problemData));
      if (temp[action.problemSlug]) {
        temp[action.problemSlug] = _assign({}, temp[action.problemSlug], {
          technology: action.languageUri,
        });
        problemTemp[action.problemSlug] = _assign(
          {},
          problemTemp[action.problemSlug],
          {
            currentStub: action.currentStub,
          }
        );
        return _assign({}, state, { solution: temp, problemData: problemTemp });
      }
      return state;
    }
    case ActionTypes.SET_LIBRARY_LOADED_SUCCESS:
      return _assign({}, state, { isLibraryDownloaded: true });
    case `${ActionTypes.RUN_CODE_CUSTOM_INPUT}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.customInputResult));
      if (!temp[action.problemSlug]) {
        temp[action.problemSlug] = { apiResponse: action.payload };
      } else {
        temp[action.problemSlug] = _assign({}, temp[action.problemSlug], {
          apiResponse: action.payload,
        });
      }
      return _assign({}, state, { customInputResult: temp });
    }
    case `${ActionTypes.RUN_CODE_TEST_CASES}_SET_LISTINER`: {
      const { slug, non_sample_testcases, sample_testcases } = action.problem;
      const temp = JSON.parse(JSON.stringify(state.testCasesResult));
      let runTestCasesStatus = [];
      if (_isArray(sample_testcases))
        runTestCasesStatus = _map(
          _sortBy(sample_testcases, [item => item.name]),
          testCase => ({
            name: testCase.name,
            id: testCase.id,
            status: null,
          })
        );
      if (_isArray(non_sample_testcases)) {
        runTestCasesStatus = _sortBy(
          _concat(
            runTestCasesStatus,
            _map(non_sample_testcases, nonSampleTestCase => ({
              name: nonSampleTestCase.name,
              id: nonSampleTestCase.id,
              status: null,
            }))
          ),
          [item => item.name]
        );
      }
      if (!temp[slug]) {
        temp[slug] = {
          solutionId: action.solutionId,
          runTestCasesStatus,
        };
      } else {
        temp[slug] = _assign({}, temp[slug], {
          solutionId: action.solutionId,
          runTestCasesStatus,
        });
      }
      return _assign({}, state, { testCasesResult: temp });
    }
    case ActionTypes.RUN_CODE_CUSTOM_INPUT_RESULT: {
      const temp = JSON.parse(JSON.stringify(state.customInputResult));
      const availableSlugs = Object.keys(temp);
      const problemSlug = availableSlugs.find(slug => {
        if (
          temp[slug].apiResponse &&
          temp[slug].apiResponse.sid &&
          temp[slug].apiResponse.sid === action.data.sid
        )
          return true;
        return false;
      });
      if (temp[problemSlug]) {
        temp[problemSlug] = _assign({}, temp[problemSlug], action.data);
      }
      return _assign({}, state, { customInputResult: temp });
    }
    case ActionTypes.RESET_RUN_CODE_DATA: {
      const temp = JSON.parse(JSON.stringify(state.customInputResult));
      const testCasesTemp = JSON.parse(JSON.stringify(state.testCasesResult));
      const { problemSlug } = action;
      /**
       * Don't remove the problemSlug from the object, it will remove the loader
       * from the run code button and show the default run code button
       */
      if (temp[problemSlug]) temp[problemSlug] = {};
      /**
       * Keep only the "solutionId" as run code on unaltered code won't run
       * the test cases again, it will directly send back the result in socket event
       */
      if (testCasesTemp[problemSlug])
        testCasesTemp[problemSlug] = {
          solutionId: testCasesTemp[problemSlug].solutionId,
        };
      return _assign({}, state, {
        testCasesResult: testCasesTemp,
        customInputResult: temp,
      });
    }
    case ActionTypes.ABORT_RUN_CODE: {
      const temp = JSON.parse(JSON.stringify(state.customInputResult));
      const testCasesTemp = JSON.parse(JSON.stringify(state.testCasesResult));
      const { problemSlug } = action;
      if (temp[problemSlug]) delete temp[problemSlug];
      if (testCasesTemp[problemSlug]) delete testCasesTemp[problemSlug];
      return _assign({}, state, {
        testCasesResult: testCasesTemp,
        customInputResult: temp,
      });
    }
    case ActionTypes.RUN_CODE_TEST_CASES_RESULT: {
      const availableSlugs = Object.keys(state.testCasesResult);
      const tempData = action.data
        ? JSON.parse(JSON.stringify(action.data))
        : {};
      const problemSlug = availableSlugs.find(slug => {
        if (
          state.testCasesResult[slug].solutionId &&
          state.testCasesResult[slug].solutionId === tempData.solution_id
        )
          return true;
        return false;
      });
      /**
       * If the user hit abort before the result comes the "testCasesResult"
       * won't have the "problemSlug". meaning we can ignore this event
       */
      if (problemSlug) {
        const temp = JSON.parse(JSON.stringify(state.testCasesResult));
        /**
         * Status of the final run code result will come along with testcases
         * only. Remove status from any other event
         */
        if (!tempData.testcases) delete tempData.status;
        temp[problemSlug] = _assign({}, temp[problemSlug], tempData);
        if (_isArray(temp[problemSlug].runTestCasesStatus)) {
          const testCaseIndex = _findIndex(
            temp[problemSlug].runTestCasesStatus,
            testCase => {
              return testCase.id === _get(tempData, 'TestCaseRunDetails.id');
            }
          );
          if (temp[problemSlug].runTestCasesStatus[testCaseIndex])
            temp[problemSlug].runTestCasesStatus[testCaseIndex] = _assign(
              {},
              temp[problemSlug].runTestCasesStatus[testCaseIndex],
              tempData.TestCaseRunDetails
            );
        }
        return _assign({}, state, { testCasesResult: temp });
      }
      return state;
    }
    case ActionTypes.RESET_PROBLEM_DATA: {
      const tempData = JSON.parse(JSON.stringify(state.problemData));
      const tempSolution = JSON.parse(JSON.stringify(state.solution));
      const { solution } = state;
      if (
        solution &&
        solution[action.problemSlug] &&
        !solution[action.problemSlug].id
      ) {
        delete tempData[action.problemSlug];
        delete tempSolution[action.problemSlug];
      }
      return _assign({}, state, {
        problemData: tempData,
        solution: tempSolution,
      });
    }
    case ActionTypes.AUTO_ABORT_RUN_CODE: {
      /**
       * Need to do auto abort when problem does not have test cases
       * So we check if there are any test cases being evaluated.
       * If yes then we don't abort the run code else we abort
       */
      const { problemSlug } = action;
      const { solution, customInputResult, testCasesResult } = state;
      const currentSolution = solution[problemSlug];
      const currentTestCasesResult = testCasesResult[problemSlug];
      const currentCustomInputResult = customInputResult[problemSlug];
      const runDetails = _get(currentSolution, 'run_details.testcases', null);
      const testResultForAbort = _get(currentTestCasesResult, 'event', null);
      const customResultForAbort = _get(
        currentCustomInputResult,
        'apiResponse.sid',
        null
      );
      if (!runDetails && !testResultForAbort && !customResultForAbort) {
        const temp = JSON.parse(JSON.stringify(state.customInputResult));
        const testCasesTemp = JSON.parse(JSON.stringify(state.testCasesResult));
        if (temp[problemSlug]) delete temp[problemSlug];
        if (testCasesTemp[problemSlug]) delete testCasesTemp[problemSlug];
        return _assign({}, state, {
          testCasesResult: testCasesTemp,
          customInputResult: temp,
        });
      }
      return state;
    }
    case `${ActionTypes.GET_TECHNOLOGIES}_SUCCESS`: {
      const tech = {
        SCR: [],
        UIX: [],
        APP: [],
        SHL: [],
        MOB: [],
        MLI: [],
        DSC: [],
        DBA: [],
        SEL: [],
        PLY: [],
        PRJ: [],
        FBE: [],
      };

      const techMap = {};
      const techMapByUri = {};
      _forEach(action.technologies, technology => {
        const temp = _clone(technology);
        temp.resource_uri = `/api/v1/technology/${temp.slug}`;
        techMap[temp.slug] = temp;
        techMapByUri[temp.resource_uri] = temp;
        _forEach(temp.allowed_in, type => {
          if (_isArray(tech[type])) tech[type].push(temp);
          else tech[type] = [temp];
        });
      });
      const technologies = {
        technologiesMap: techMap,
        technologiesMapByUri: techMapByUri,
        technologies: tech,
      };
      return _assign({}, state, {
        technologies,
      });
    }
    case ActionTypes.SET_TEST_QUERY: {
      const problemData = {
        ...state.problemData,
        [action.problemSlug]: {
          ...state.problemData[action.problemSlug],
          isTestQuery: action.isTestQuery,
        },
      };
      return { ...state, problemData };
    }
    default:
      return state;
  }
};
